import { logError } from '@/utils/errorReporter'
import type { UserInfoResponse, UserDataResponse } from '@/navbar/navbar.types'

export default class IdentityApi {
  constructor(private readonly domain: string, private readonly getToken?: () => Promise<string>) {
    if (!domain.startsWith('https://') && !domain.startsWith('http://')) {
      this.domain = `https://${this.domain}`
    }

    if (this.domain.endsWith('/')) {
      this.domain = this.domain.slice(0, -1)
    }
  }

  async fetch(url: string) {
    const token = await this.getToken?.() ?? ''

    const response = await fetch(`${this.domain}/${url}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) throw new Error(`Failed to fetch from ${url}`)

    const contentType = response.headers.get('Content-Type') ?? ''
    if (!contentType.includes('application/json')) {
      throw new Error(`Unexpected content type from ${url}: ${contentType}`)
    }

    return response.json?.()
  }

  async fetchUser(): Promise<{
    userInfo: UserInfoResponse
    userData: UserDataResponse
  } | null> {
    try {
      const userInfo = await this.fetch('userinfo')
      const userData = await this.fetch('api/platform/userdata')

      return { userInfo, userData }
    } catch (error) {
      logError(error, { source: 'IdentityApi.fetchUser' })
      return null
    }
  }
}
